import React from 'react';
import { AccordionContainer } from '../../../../../../common/components/accordion/accordion.module';
import { InputContainer } from '../../../../../../common/components/form/form.module';

export const TransporterAccountInfoComponent = ({ stores, accounts, onInnerFormChange, selectedTransporters }: any) => (
  <>
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="PersonAccount"
            name="IsPersonAccount"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'Account.IsPersonAccount',
                selectedTransporters?.Account
              )
            }}
            type="checkbox"
            value={selectedTransporters?.Account?.IsPersonAccount}
          />
          <InputContainer
            label="Name"
            name="Name"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.Name',
                selectedTransporters?.Account
              )
            }}
            type="text"
            value={selectedTransporters?.Account?.Name}
          />
          <InputContainer
            label="Number Of Vehicles"
            name="NumberOfVehicles"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.NumberOfVehicles',
                selectedTransporters?.Account
              )
            }}
            type="number"
            value={selectedTransporters?.Account?.NumberOfVehicles}
          />
          <InputContainer
            label="Account"
            labelField="Name"
            list={accounts}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'Account.AccountId',
                selectedTransporters?.Account
              )
            }}
            optionName="Choose Account"
            type="select"
            value={selectedTransporters?.Account?.AccountId}
            valueField="Id"
          />

        </div>
      }
      expandedPanel="accountInfo"
      headerTitle="Account Info"
    />
    <AccordionContainer
      child={
        <div className=' grid md:grid-cols-3 lg:grid-cols-4 gap-4'>
          <InputContainer
            label="TransporterLoginVerified"
            name="IsTransporterLoginVerified"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event,
                'TransporterInfo.IsTransporterLoginVerified',
                selectedTransporters?.TransporterInfo
              )
            }}
            type="checkbox"
            value={selectedTransporters?.TransporterInfo?.IsTransporterLoginVerified}
          />

          <InputContainer
            label="Store"
            labelField="StoreName"
            list={stores}
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'TransporterInfo.PrimaryStoreId',
                selectedTransporters?.TransporterInfo
              )
            }}
            optionName="Choose Store"
            type="select"
            value={selectedTransporters?.TransporterInfo?.PrimaryStoreId}
            valueField="Id"
          />
          <InputContainer
            label="Remarks"
            name="Remarks"
            onValueChange={(event: any) => {
              onInnerFormChange(
                event.target.value,
                'TransporterInfo.Remarks',
                selectedTransporters?.TransporterInfo
              )
            }}
            type="text"
            value={selectedTransporters?.TransporterInfo?.Remarks}
          />

        </div>
      }
      expandedPanel="TransporterInfo"
      headerTitle="Transporter Info"
    />
  </>
)
export default TransporterAccountInfoComponent;
